import styled from 'styled-components';

export default styled.div`
  margin-bottom: 2px;
  color: #333333;
  font-size: 12px;
  line-height: 16px;
`;
